// MyContextProvider.js

import React, { createContext, useEffect, useState } from 'react';
import { useToast } from '@chakra-ui/react';

const BrowserContext = createContext(null);

const BrowserProvider = () => {
  const toast = useToast();
  const [browser, setBrowser] = useState<string>();

  useEffect(() => {
    checkBrowser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkBrowser = () => {
    const userAgent = window.navigator.userAgent;
    let browserType = "";
    // console.log(userAgent);
    if (userAgent.includes("Mobile")) {
      // 모바일 브라우저인 경우 추가 처리
      if (userAgent.includes("CriOS") || userAgent.includes("Chrome")) {
        browserType = "Chrome";
      } else if (userAgent.includes("FxiOS")) {
        browserType = "Firefox";
      } else if (userAgent.includes("EdgiOS")) {
        browserType = "Edge";
      } else if (userAgent.includes("Safari") && userAgent.includes("Version/")) {
        browserType = "Safari";
      } else {
        browserType = "Mobile";
      }
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
      browserType = "IE";
    } else if (userAgent.includes("Chrome")) {
      browserType = "Chrome";
    } else if (userAgent.includes("Safari")) {
      browserType = "Safari";
    } else if (userAgent.includes("Firefox")) {
      browserType = "Firefox";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      browserType = "Opera";
    } else {
      browserType = "Unknown";
    }
    setBrowser(browserType);
    // toast({ title: `${userAgent}, ${browserType}`, status: "info" });
    if(browserType !== "Chrome") {
      toast({ title: "쾌적한 사용을 위해서는 Chrome 브라우저 사용을 권장합니다.", status: "info" });
    }
  };


  return (
    <BrowserContext.Provider value={browser} />
  );
};

export {BrowserProvider, BrowserContext};
